






































import Vue from 'vue';
import { getSubscription, getSubscriptionsPaymentOption } from '@/modules/event/subscription.service';
import { getEventWithGuestCategoryCounters } from '@/modules/event/event.service';
import SubscriptionPaymentDetails from '@/components/SubscriptionPaymentDetails';
import SubscriptionGuestAnswers from '@/components/SubscriptionGuestAnswers';

export default Vue.extend({
  components: { SubscriptionPaymentDetails, SubscriptionGuestAnswers},
  data () {
    return {
      pageTitle: "Confirmation de l'inscription",
      eventId: 0,
      subscriptionId: 0,
      event: {},
      subscription: {},
      paymentOption: {},
      guestCategoriesCounter: [],
      updateUrl: ''
    }
  },
  methods: {
    fillPageEvent(){
      if (this.eventId > 0){
        getEventWithGuestCategoryCounters(this.eventId).then(resEvent=>{
          if(resEvent.data) {
            this.event = resEvent.data.event;
            this.guestCategoriesCounter = resEvent.data.counters;
            const date = new Date(this.event.date);
            //this.event.date = date.getFullYear()+'-'+(date.getMonth()+1<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+'-'+((date.getDate()<10)?('0'+date.getDate()):date.getDate());
            //this.event.dateString = date.getFullYear()+'/'+(date.getMonth()+1<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+'/'+((date.getDate()<10)?('0'+date.getDate()):date.getDate());
            this.event.dateString = ((date.getDate()<10)?('0'+date.getDate()):date.getDate())+'/'+(date.getMonth()+1<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+'/'+date.getFullYear();            
            
            
            if(this.subscriptionId > 0) { 
              getSubscription(this.subscriptionId).then(res=>{
                if(res.data) {
                  this.subscription = res.data;
                  const resSubscription = res.data;
                  
                  // create cache objects (of guests and answers) while looping through the guest list
                  const guestsByCategories = {};
                  const answersByGuestsQuestions = {};
                  for(const i in resSubscription.guests) {
                    const resSubscriptionGuest = resSubscription.guests[i];
                    const guestCategoryId = resSubscriptionGuest.guestCategoryId;
                    const guestId = resSubscriptionGuest.id;
                    
                    for(const j in resSubscriptionGuest.answers) {
                      const thisAnswer = resSubscriptionGuest.answers[j];
                      const questionId = thisAnswer.questionId;
                      
                      if(typeof answersByGuestsQuestions[guestId] == 'undefined') answersByGuestsQuestions[guestId] = {};
                      answersByGuestsQuestions[guestId][questionId] = {
                        answerId: thisAnswer.id,
                        answer: thisAnswer.answer
                      };
                    }
                    
                    if(typeof guestsByCategories[guestCategoryId] == 'undefined') guestsByCategories[guestCategoryId] = [];
                    guestsByCategories[guestCategoryId].push({
                      id: resSubscriptionGuest.id,
                      firstname: resSubscriptionGuest.firstName,
                      lastname: resSubscriptionGuest.lastName
                    });
                  }
                  this.cacheAnswers = answersByGuestsQuestions;
                  
                  // recreate the subscription object used for the UI
                  const thisSubscription = {guestCategories: [], id: resSubscription.id, email: resSubscription.email, phonenumber: resSubscription.phoneNumber};
                  for(const i in this.guestCategories) {
                    const thisCategoryId = this.guestCategories[i].id;
                    let thisGuests = [];
                    if(typeof guestsByCategories[thisCategoryId] != 'undefined') {
                      thisGuests = guestsByCategories[thisCategoryId];
                    }
                    const guests = [];
                    
                    for(const j in thisGuests) {
                      const thisGuest = thisGuests[j];
                      
                      guests.push(this.generateGuestObject(thisCategoryId, thisGuest));
                      this.totalGuestsCounter++;
                    }
                    
                    const thisSubscriptionGuestCategory = {
                      id: thisCategoryId,
                      number: thisGuests.length?thisGuests.length:0,
                      name: this.guestCategories[i].name,
                      guests: guests
                    };
                    
                    thisSubscription.guestCategories.push(thisSubscriptionGuestCategory);
                  }
                  //this.subscription = thisSubscription;
                } else if(res.error) {
                  this.eventError = 'Erreur. Impossible de récupérer les données de l\'inscription.'
                }
              });
              getSubscriptionsPaymentOption(this.subscriptionId).then(res=>{
                if(res.data) {
                  this.paymentOption = res.data;
                } else if(res.error) {
                  this.eventError = 'Erreur. Impossible de récupérer les données de l\'inscription.'
                }
              });
            } 
          } else if(resEvent.error) {
            this.eventError = 'Erreur. Impossible de récupérer les données événements.'
          }
        });
      }
    }
  },
  mounted: function() {
    if (this.$route.query.id_event){
      this.eventId = this.$route.query.id_event;
    }  
    if (this.$route.query.id_subscription){
      this.subscriptionId = this.$route.query.id_subscription;
    }
    if (this.$route.query.edition){
      this.pageTitle = "Modification de l'inscription";
    }
    this.fillPageEvent()
    const props = this.$router.resolve({ 
      name: 'Inscription',
      query: { "id_event": this.eventId, "id_subscription": this.subscriptionId },
    });
    this.updateUrl = props.href;
  }
})
